document.addEventListener("DOMContentLoaded", function() {
 function showZipLink(zipCode) {
  const zipLink = document.getElementById("zipLink");
  const zipInput = document.getElementById("zipInput");
  const zipSubmit = document.getElementById("zipSubmit");

  zipLink.style.display = "inline";
  zipLink.textContent = zipCode;
  zipLink.style.cursor = "pointer";
  zipLink.style.textDecoration = "underline";

  zipLink.addEventListener("click", function() {
    showZipInput();
  });
}

function showZipInput() {
  const zipInput = document.getElementById("zipInput");
  const zipSubmit = document.getElementById("zipSubmit");
  const zipLink = document.getElementById("zipLink");

  zipInput.style.display = "inline";
  zipSubmit.style.display = "inline";
  zipLink.style.display = "none";

  // Focus on the input field when it appears
  zipInput.focus();
}

function getDefaultZipCode() {
  fetch("https://ipinfo.io/json")
    .then(response => response.json())
    .then(data => {
      const zipCode = data.postal || "77036"; // Default to a general zip code if none found
      localStorage.setItem("visitorZipCode", zipCode);
      updateZipDependentContent(zipCode); // Update content based on zip code (if needed)
      showZipLink(zipCode); 
      document.dispatchEvent(new CustomEvent('zip-code-loaded', { detail: { zipCode } }));
    })
    .catch(error => {
      console.error("Error fetching zip code:", error); 
      localStorage.setItem("visitorZipCode", "77036");
      updateZipDependentContent("77036"); // Update content based on zip code (if needed)
      showZipLink("77036"); // Show a default zip code
      document.dispatchEvent(new CustomEvent('zip-code-loaded', { detail: { zipCode } }));
    });
}

document.getElementById("DeliveryZipForm").addEventListener("submit", function(e) {
  e.preventDefault();
  const zipCode = document.getElementById("zipInput").value.trim();

  if (zipCode && isValidZipCode(zipCode)) { // Validate zip code before proceeding
    localStorage.setItem("visitorZipCode", zipCode);
    updateZipDependentContent(zipCode);
    showZipLink(zipCode);
    location.reload();
  } else {
    // Handle invalid zip code (display error, etc.)
    alert("Please enter a valid ZIP code.");
  }
});

// Function to validate zip code (you can customize this)
function isValidZipCode(zipCode) {
  return /^\d{5}(-\d{4})?$/.test(zipCode); // Basic US zip code format
}

// (Function to update other page content based on zip code)
function updateZipDependentContent(zipCode) {
  document.getElementById("zipInput").style.display = "none"; // Hide the input field
  document.getElementById("zipSubmit").style.display = "none"; // Hide the submit button
}

// Initialize based on stored or default zip code
const initialZipCode = localStorage.getItem("visitorZipCode");
if (initialZipCode) {
  updateZipDependentContent(initialZipCode);
  showZipLink(initialZipCode);
} else {
  showZipInput();
  getDefaultZipCode(); 
}
});